module.exports = __webpack_public_path__ + "img/harry_potter_01_and_the_sorcerers_stone.6d72be01.jpg";